/**
 * Call list block of Thim Real Estate
 */
import { registerBlockType } from '@wordpress/blocks';
import * as single from './legacy-template/single';
import * as archive from './legacy-template/archive';
import * as listProperties from './list-properties';
import * as priceProperty from './property/price';
import * as titleProperty from './property/title';

const getAllBlock = () => {
	// return [ archive, single, listProperties, priceProperty, titleProperty ];
	return [ single, archive, listProperties, titleProperty, priceProperty ];
};

getAllBlock().forEach( ( block ) => {
	const { settings } = block;

	registerBlockType( settings.name, { ...settings } );
} );
